import React from 'react';
import { Box } from 'reactjs-admin-lte';
import TooltipIconButton from 'components/core/TooltipIconButton';
import DocumentTable from 'components/documents/DocumentTable';


const JobCommonReference = (props) => {

  const {
    title,
    isLoading,
    files,
    uploadable,
    showUploadModal,
    handleDownload,
    removable,
    sizeVisible,
    handleRemove
  } = props;

  return (
    <Box
      className="box-widget"
      loading={isLoading}>
      <Box.Header border={true}>
        <Box.Title>{title}</Box.Title>
        <Box.Tools>
          { uploadable && 
            <TooltipIconButton
              id="upload-new-reference"
              className="btn-box-tool"
              icon="upload"
              description="Upload Job Common Reference"
              onClick={showUploadModal} />
          }
          <Box.CollapsedToggleButton />
        </Box.Tools>
      </Box.Header>
      <Box.Body noPadding={true}>
        <DocumentTable
          documents={files}
          removable={removable}
          sizeVisible={sizeVisible}
          handleDownload={handleDownload}
          handleRemove={handleRemove} />
      </Box.Body>
    </Box>
  )
}

JobCommonReference.defaultProps = {
  title: 'Job Common References',
  uploadable: false,
  removable: false
}

export default JobCommonReference;
